import React, { useEffect, useRef } from 'react';
import './ConfirmModal.css';

/**
 * In-app confirmation (replaces window.confirm, which looks foreign and
 * cannot be styled or made touch-friendly). Escape and the backdrop cancel;
 * focus lands on the safe choice. A dialog on wide screens, a sheet on phones.
 * `danger` marks an action that can't be undone: the words say so, and the
 * button stays a line button (red is a status, never an action, §11.0).
 */
function ConfirmModal({ title, body, confirmLabel = 'Confirm', cancelLabel = 'Cancel', danger = false, busy = false, onConfirm, onCancel }) {
  const cancelRef = useRef(null);

  useEffect(() => {
    cancelRef.current?.focus();
    const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel]);

  return (
    <div className="apr-overlay confirm-overlay" role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget) onCancel(); }}>
      <div className={`apr-dialog confirm-modal${danger ? ' danger' : ''}`} role="dialog" aria-modal="true" aria-labelledby="confirm-title">
        <span className="apr-dialog-grabber" aria-hidden="true" />
        <h3 id="confirm-title" className="apr-dialog-title">{title}</h3>
        {body && <div className="confirm-body">{body}</div>}
        <div className="apr-dialog-actions confirm-actions">
          <button ref={cancelRef} type="button" className="apr-btn apr-btn--quiet confirm-btn cancel" onClick={onCancel} disabled={busy}>{cancelLabel}</button>
          <button type="button" className={`apr-btn confirm-btn ${danger ? 'danger' : 'primary'}`} onClick={onConfirm} disabled={busy}>
            {busy ? 'Working…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
